export default "__VITE_ASSET__BP2exk4n__"